import { useProject } from "@hooks/crud/useProject";
import { useNavigate } from "react-router-dom";
import * as RouteHelper from "@utils/routes";
import { ProjectTable } from "@stories/organisms/Tables/ProjectTable";
import { ProjectLineItem } from "@interfaces/project";
import { PageLoader } from "@stories/atoms/Loaders/PageLoader/PageLoader";
import { SubTitleWithImage } from "@stories/atoms/SubTitle/SubTitle";
import { useProfileContext } from "@hooks/context/useProfileContext";
import { Grid } from "@mui/material";
import { StyledCard } from "@stories/atoms/StyledCard/StyledCard";
import { StyledButton } from "@stories/atoms/StyledButton/StyledButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
export const ListProjects = (): JSX.Element => {
  const navigate = useNavigate();

  const { userProfile, userOrganisation } = useProfileContext();

  if (!userProfile) {
    throw new Error("No user profile to list projects");
  }
  const { isProjectLoading, projects } = useProject(userProfile);

  const handleAddProject = () => {
    navigate(RouteHelper.project());
  };

  const handleEditProject = (project: ProjectLineItem) => {
    navigate(RouteHelper.project(project.id));
  };

  const handleViewProject = (project: ProjectLineItem) => {
    navigate(RouteHelper.contractorDashboard(project.id));
  };

  const handleArchiveProject = (project: ProjectLineItem) => {
    console.log("Archive");
  };

  if (!userProfile) {
    console.log("List projects PAGE LOADER");
    return <PageLoader />;
  }
  return (
    <>
      <StyledCard>
        <Grid container spacing={2} sx={{ padding: "12px" }}>
          <Grid item xs={12} md={10}>
            <SubTitleWithImage
              title={`${userOrganisation?.organisationName} Projects`}
              url={userOrganisation?.organisationLogo || ""}
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={2}
            sx={{
              display: "flex",
              alignContent: "right",
              justifyContent: "right",
              margin: "auto",
            }}
            justifyContent={"right"}
          >
            <StyledButton
              variant="contained"
              startIcon={<AddCircleIcon />}
              onClick={handleAddProject}
            >
              Add Project
            </StyledButton>
          </Grid>
        </Grid>
      </StyledCard>
      <StyledCard>
        <Grid container spacing={2} sx={{ padding: "12px" }}>
          <Grid item xs={12} md={12}>
            <ProjectTable
              projects={projects}
              loading={isProjectLoading}
              handleViewProject={handleViewProject}
              handleEditProject={handleEditProject}
              handleArchiveProject={handleArchiveProject}
            />
          </Grid>
        </Grid>
      </StyledCard>
    </>
  );
};
